<template>
  <div>
    <Header/>
    <Navigationzj :toptNavi="6"/>
    <div class="sybanner">
      <div class="bd">
        <ul>
          <li class="newBackImg">
            <a class="Supplier-click" @click="Suppliershow()"></a>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="show">
      <div class="Apply">
        <h2>申请加入</h2>
        <em></em>
        <span></span>
        <i>Apply join</i>
      </div>
      <div class="Apply-form">
        <el-form ref="dataForm" :rules="rules" :model="formData">
        <div class="Apply-form-top clearfix">
          <div class="h_gsmc clearfix">
            <span>公司名称：</span>
            <el-form-item prop='company_name'>
              <el-input id="supplier_name" v-model="formData.company_name" placeholder="请输入公司名称" class="inputext"></el-input>
            </el-form-item>
          </div>
          <div class="h_lxr clearfix">
            <span>联系人：</span>
            <el-form-item prop='name'>
              <el-input id="name" v-model="formData.name" placeholder="请输入您的名字" class="inputext"></el-input>
            </el-form-item>
          </div>
          <div class="h_phonenumber clearfix">
            <span>手机号：</span>
            <el-form-item prop='tel'>
              <el-input id="tel" v-model="formData.tel" placeholder="请输入您的手机号" class="inputext"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="Apply-form-content">
          <div class="clearfix">
            <span>合作留言：</span>
            <el-form-item prop='content' style="width: 88% !important;">
              <el-input id="content" type="textarea" maxlength="300" :rows="3" v-model="formData.content" placeholder="请留言~" class="inputextarea"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="h_btx">
          以上均为必填项
        </div>
        <div class="Apply-bottom clearfix" style="margin-bottom:20px;">
          <div>
            <span>验证码：</span>
            <el-form-item prop='code'>
              <el-input id="code" v-model="formData.code" placeholder="请输入您的验证码" class="inputext"></el-input>
            </el-form-item>
            <a class="login-code" @click="refreshCode" style="width:109px !important">
              <!--验证码组件-->
              <s-identify :identifyCode="identifyCode" :contentHeight="55"></s-identify>
            </a>
          </div>
          <a href="javascript:;" id="btn" @click="subSupplier">提交</a>
        </div>
        </el-form>
      </div>
      <div class="Apply">
        <h2>合作流程</h2>
        <em></em>
        <span></span>
        <i>Cooperation process</i>
      </div>
      <div class="Cooperation">
        <ul class="clearfix">
          <li>
            <div class="Cooperation-content">
              <div>01<span>资料提交</span></div>
              <i>公司简介及产品资料及相关资历证明。</i>
            </div>
          </li>
          <li>
            <div class="Cooperation-content">
              <div>02<span>内容审核</span></div>
              <i>工作人员对信息进行审核。</i>
            </div>
          </li>
          <li>
            <div class="Cooperation-content">
              <div>03<span>合作回访</span></div>
              <i>审核通过后，工作人员进行线下回访及合作</i>
            </div>
          </li>
          <li>
            <div class="Cooperation-content">
              <div>04<span>达成合作</span></div>
              <i>成为志鹏合格供应商并长期合作。</i>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="show == false" class="zmpp_con w1200" style="text-align:center;">
      <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
        <el-tab-pane label="供应商入驻" name="1">
          <div class="demo-image__preview" style="width:100%;display: inline-block;">
            <ul class="clearfixs demo-image__preview">
              <li class="demo-image__preview" v-for="(item,index) in supplierList" :key="index">
                <el-image
                  :src="item.imgpath"
                  :preview-src-list="imgList"
                  :large="item.imgpath"
                  fit="cover"
                  preview="0"
                  @click="handleClickItem"
                  >
                  <div slot="error" class="image-slot">
                    <img src="../../assets/images/zwtp.jpg"/>
                  </div>
                </el-image>
                <h3>{{item.title}}</h3>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="品牌授权" name="2">
          <div class="demo-image__preview" style="width:100%;display: inline-block;">
            <ul class="clearfixs demo-image__preview">
              <li class="demo-image__preview" v-for="(item,index) in supplierList" :key="index">
                <el-image
                  :src="item.imgpath"
                  :preview-src-list="imgList"
                  :large="item.imgpath"
                  fit="cover"
                  preview="0"
                  @click="handleClickItem"
                  >
                  <div slot="error" class="image-slot">
                    <img src="../../assets/images/zwtp.jpg"/>
                  </div>
                </el-image>
                <h3>{{item.title}}</h3>
              </li>
            </ul>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="hxq_subpage" style="text-align:left;">
        <pagination v-show="total>12" :total="total" :pageSizes="[12, 24, 36, 48, 60]" :page.sync="listQuery.page" :limit.sync="listQuery.limit"  @pagination="getSupplier" />
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import api from '@/api/cooperation'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'
import SIdentify from '@/components/SIdentify'
import Pagination from '@/components/Pagination'

export default {
  name: 'Supplier',
  components: {
    Header,
    Navigationzj,
    Footer,
    SIdentify,
    Pagination
  },
  data () {
    return {
      qyloading: false,
      identifyCodes: '1234567890',
      identifyCode: '',
      rules: {
        company_name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入您的手机号', trigger: 'blur' }],
        content: [{ required: true, message: '请留言', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      formData: {
        company_name: '',
        name: '',
        tel: '',
        content: ''
      },
      lodaing: false,
      show: true,
      supplierList: [],
      supplierCount: '',
      imgList: [],
      total: 0,
      listQuery: {
        limit: 12,
        order: 'order_num',
        sort: 'asc',
        type: 1
      },
      activeName: '1'
    }
  },
  mounted () {
    this.identifyCode = ''
    this.makeCode(this.identifyCodes, 4)
    this.getSupplier()
  },
  methods: {
    // 验证码
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    refreshCode () {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },
    subSupplier () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.lodaing) {
            return false
          }
          this.lodaing = true
          if (this.identifyCode !== this.formData.code) {
            this.$message.error('请输入正确的验证码')
            return false
          }
          api.subSupplier(this.formData).then(res => {
            this.refreshCode()
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            this.formData = {
              company_name: '',
              name: '',
              tel: '',
              content: '',
              code: ''
            }
            this.lodaing = false
          })
        }
      })
    },
    Suppliershow () {
      if (this.show) {
        this.$prompt('请输入密码', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
          inputValidator: (value) => { // 点击按钮时，对文本框里面的值进行验证
            if (!value) {
              return '输入不能为空'
            }
          }
        }).then(({ value }) => {
          if (value === '123456') {
            this.show = false
          } else {
            this.$message({
              type: 'error',
              message: '您的密码有误'
            })
          }
        }).catch(() => {})
      } else {
        this.show = true
      }
    },
    getSupplier () {
      api.getSupplier(this.listQuery).then(res => {
        this.supplierList = res.items
        this.imgList = res.imgList
        this.total = res.total
      })
    },
    handleClickItem () {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    handleClick (tab) {
      this.listQuery['type'] = tab.name
      this.listQuery['page'] = 1
      this.getSupplier()
    }
  }
}
</script>
<style scoped>
  .atpresent_title{
    font-weight: 600;
  }
  .clearfix {
    zoom: 1
}
.login-code{
  cursor: pointer;
}
.newBackImg{
  width: 100%;
  height: 400px;
  background: url(../../assets/images/index_img.jpg) 0% 0% / 100% 100% no-repeat;
  margin-top: 15px;
  position: relative;
}
* {
    text-decoration: none;
}

a {
    outline: none;
    color: #333;
}

body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, fieldset, lengend, button, input, textarea, th, td {
    margin: 0;
    padding: 0;
    outline: none;
}
.clearfix:after {
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    content: '';
}

input {
    background: none;
    border: none;
    font-family: none;
}

ul li {
    list-style: none;
}

img {
    border: none;
    vertical-align: middle;
}

body {
    font-family: 微软雅黑;
    background: #fff;
}

address, cite, dfn, em, var, i {
    font-style: normal;
}

.w1200 {
    width: 1200px;
    margin: 0 auto;
}
.sybanner {
    width: 1200px;
    height: 350px;
    overflow: hidden;
    position: relative;
    margin: 0 auto;
}

.sybanner, .sybanner .bd, .sybanner .bd ul, .sybanner .bd ul li {
    display: block;
    width: 1200px;
    height: 350px;
    overflow: hidden;
}
.Apply {
    width: 100%;
    max-width: 1200px;
    margin: 55px auto 0;
    text-align: center;
}

.Apply h2 {
    font-size: 32px;
    font-weight: normal;
    color: #000000;
    line-height: 66px;
}

.Apply em {
    width: 100px;
    height: 4px;
    background-color: #0859af;
    display: block;
    margin: 0 auto;
}

.Apply span {
    width: 245px;
    height: 1px;
    background-color: #0859af;
    display: block;
    margin: -2px auto 0;
}

.Apply i {
    font-size: 16px;
    color: #c7c7c7;
    font-weight: normal;
    line-height: 30px;
    padding-top: 10px;
    display: block;
}

.Apply-form {
    width: 100%;
    max-width: 1140px;
    margin: 0 auto;
    overflow: hidden;
}

.Apply-form-top {
    width: 100%;
    max-width: 1200px;
    margin: 60px auto 0;
}

.Apply-form-top div {
    width: 360px;
    height: 55px;
    float: left;
    background-color: #fafafc;
    border-radius: 5px;
}

.Apply-form-top .h_phonenumber {
    float: right;
}

.Apply-form-top .h_lxr {
    margin: 0 30px;
}

.Apply-form-top div span {
    display: block;
    font-size: 16px;
    font-weight: normal;
    color: #333333;
    line-height: 55px;
    float: left;
    background: url(../../assets/images/h_icon.png) no-repeat left center;
    margin-left: 15px;
    padding-left: 30px;
}

.Apply-form-top .h_lxr span {
    background: url(../../assets/images/h_icon1.png) no-repeat left center;
}

.Apply-form-top .h_phonenumber span {
    background: url(../../assets/images/h_icon2.png) no-repeat left center;
    padding-left: 25px;
}

.Apply-form-top div input {
    width: 60%;
    float: left;
    height: 55px;
    line-height: 55px;
    font-size: 14px;
}

.Apply-form-content {
    width: 100%;
    height: 150px;
    background-color: #fafafc;
    overflow: hidden;
    margin-top: 30px;
    border-radius: 5px;
}

.Apply-form-content div span {
    display: block;
    font-size: 16px;
    font-weight: normal;
    color: #333333;
    line-height: 55px;
    float: left;
    background: url(../../assets/images/h_icon3.png) no-repeat left center;
    margin-left: 15px;
    padding-left: 30px;
}

.Apply-form-content div textarea {
    font-size: 14px;
    font-weight: normal;
    color: #999;
    line-height: 36px;
    float: left;
    width: 88%;
    margin: 10px 0;
    height: 124px;
    background: none;
    border: none;
    margin-left: 5px;
    font-family: 微软雅黑;
    overflow-y: auto;
    resize: none;
}

.h_btx {
    font-size: 14px;
    font-weight: normal;
    color: #d10000;
    line-height: 62px;
    background: url(../../assets/images/h_icon4.png) no-repeat left center;
    margin-left: 15px;
    padding-left: 30px;
}

.Apply-bottom div {
    width: 550px;
    height: 55px;
    float: left;
    background-color: #fafafc;
}

.Apply-bottom div span {
    display: block;
    font-size: 16px;
    font-weight: normal;
    color: #333333;
    line-height: 55px;
    float: left;
    background: url(../../assets/images/h_icon5.png) no-repeat left center;
    margin-left: 15px;
    padding-left: 30px;
}

.Apply-bottom div input {
    width: 58%;
    float: left;
    height: 55px;
    line-height: 55px;
    font-size: 14px;
}

.Apply-bottom div a {
    display: block;
    float: right;
    width: 120px;
    height: 55px;
}

.Apply-bottom div a img {
    width: 100%;
    height: 100%;
}

.Apply-bottom>a {
    display: block;
    float: right;
    width: 550px;
    height: 55px;
    background-color: #07357b;
    border-radius: 5px;
    font-size: 16px;
    font-weight: normal;
    color: #fff;
    text-align: center;
    line-height: 55px;
}

.Apply-bottom>a:hover {
    background-color: #e50000;
}

.Cooperation {
    width: 100%;
    max-width: 1200px;
    margin: 60px auto 100px;
    overflow: hidden;
}

.Cooperation ul  {
    margin-right: -101px;
}

.Cooperation ul li {
    width: 224px;
    height: 201px;
    text-align: center;
    float: left;
    margin-right: 101px;
    background: url(../../assets/images/h_y.png) no-repeat center;
}

.Cooperation ul .Cooperation-content {
    padding: 35px 0;
    width: 140px;
    text-align: center;
    margin-left: 30px;
}

.Cooperation ul .Cooperation-content div {
    font-size: 38px;
    color: #fff;
    line-height: 62px;
    border-bottom: 1px solid #adc2e3;
    margin-bottom: 10px;
}

.Cooperation ul .Cooperation-content div span {
    font-size: 18px;
    color: #fff;
    margin-left: 10px;
}

.Cooperation ul .Cooperation-content i {
    font-size: 14px;
    color: #d5e5fe;
    line-height: 24px;
}
.el-form-item{
  float: left !important;
  width: 60% !important;
}
.el-form-item >>> .el-input__inner{
    border: none !important;
    height: 55px !important;
    line-height: 55px !important;
    padding: 0 !important;
    float: left !important;
    width: 100% !important;
    background-color: #fafafc;
}
.inputext{
  width: 216px !important;
}
.el-form-item >>> .el-textarea__inner{
  width: 100% !important;
  height: 124px !important;
  background-color: #fafafc;
  border: none !important;
  padding: 15px 0 0 0 !important;
}
.Supplier-click {
  position: absolute;
  display: block;
  width: 200px;
  height: 50px;
  top: 167px;
  left: 720px;
  cursor: pointer;
}
.clearfixs li {
  width: 24%;
  margin: 12px 5px;
  float: left;
}
.clearfixs li img {
  width: 100%;
  border: 1px solid #efefef;
  height: 370px;
}
.clearfixs h3{
  margin: 10px;
  height: 20px;
}
.el-image {
  height:370px;
  position: relative;
  display: inline-block;
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/view/about/supplier.vue